import { useAuth } from '../auth/AuthProvider';
import { Logo } from '../components/Logo';

export function ContactHrPage() {
  const { signOut } = useAuth();

  return (
    <main className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md space-y-10">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <Logo themed className="h-7" />
          </div>
        </div>

        <div className="space-y-6 border-hairline border-line p-8">
          <h1 className="font-display text-xl tracking-tightest">
            Account not yet configured
          </h1>
          <p className="text-sm text-fg-muted leading-relaxed">
            Welcome. Your account exists but hasn&rsquo;t been fully set up yet
            — HR needs to set your payout currency before you can submit
            expenses.
          </p>
          <p className="text-sm text-fg-muted leading-relaxed">
            Please contact HR at{' '}
            <a
              href="mailto:hr@daaily.com"
              className="text-fg underline underline-offset-2"
            >
              hr@daaily.com
            </a>
            . Once your profile is set up, this page will refresh on its own
            — no need to sign back in.
          </p>
        </div>

        <div className="text-center">
          <button
            type="button"
            onClick={() => void signOut()}
            className="text-xs text-fg-muted hover:text-fg transition-colors tracking-tighter"
          >
            Sign out
          </button>
        </div>
      </div>
    </main>
  );
}
